import ReactMapboxGl from 'react-mapbox-gl';

const ConfiguredMapboxGl = ReactMapboxGl({
  accessToken: 'pk.eyJ1Ijoic2NydW1weSIsImEiOiJjamw1and5N2gyZmQzM2txcmFnd3M1aWMwIn0.26Z77DZIFDchXWhm67Qn8w'
});

export const MapboxStyle = 'https://api.maptiler.com/maps/17a15173-4a83-4150-9671-7a3300fb7df2/style.json?key=IoGVfrAT6JTUaDcvLQMv';

export default ConfiguredMapboxGl;
